
import { Component, Vue, Prop } from 'vue-property-decorator'
import FetchWrapper from '@/classes/fetchWrapper'

const CreateAssessmentTemplateModalProps = Vue.extend({
  props: {
    canCancel: Boolean,
    close: Boolean,
    types: Array,
    categories: Array,
    selectedUserId: Number
  }
})

Vue.prototype.$multiwatch = function (props, watcher) {
  var iterator = function (prop) {
    this.$watch(prop, watcher)
  }
  props.forEach(iterator, this)
}

@Component
export default class CreateAssessmentTemplateModal extends CreateAssessmentTemplateModalProps {
  data () {
    return {
      isLoading: false,
      activeStep: 0,
      hasStep2: false,
      title: '',
      description: '',
      prompt: '',
      keywords: [],
      selectedType: '',
      selectedCategory: '',
      isFormValid: false,
      sampleQuote: '',
      sampleOutput: ''
    }
  }

  get isComponentModalActive () {
    return this.close
  }

  created () {
    this.$multiwatch(['title', 'description', 'prompt', 'sampleQuote', 'keywords', 'selectedType', 'selectedCategory'], function () {
      this.validateForm()
    })
  }

  addKeyword () {
    this.keywords.push({ value: '' })
  }

  removeKeyword (idx) {
    this.keywords.splice(idx, 1)
  }

  getFormattedKeywords () {
    var list = this.keywords.map((item) => { return item.value })
    return list.join(', ')
  }

  validateForm () {
    this.isFormValid = this.$refs.form.checkValidity() && this.selectedType !== '' && this.selectedCategory !== ''
  }

  setKeyword (event, idx) {
    event.stopPropagation()
    this.keywords[idx] = { value: event.target.value }
    // this.settingStart = false
    this.validateForm()
  }

  inputFocused (evt) {
    evt.stopPropagation()
  }

  async testPrompt () {
    try {
      this.isLoading = true
      var body = {
        prompt: `${this.prompt} "${this.sampleQuote}"`
      }
      var resp = await FetchWrapper.post(encodeURI(`${process.env.VUE_APP_SERVERURL}/runAssessmentTemplateInference/${this.selectedUserId}`), body)
      if (resp.error) {
        this.isLoading = false
        this.$buefy.dialog.confirm({
          title: 'Error',
          message: resp.error,
          canCancel: false
        })
      } else {
        this.sampleOutput = resp.result
        this.isLoading = false
        this.activeStep = 1
        this.hasStep2 = true
      }
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Something went wrong. ${e}`,
        canCancel: false
      })
    }
  }

  async createAssessmentTemplate () {
    try {
      this.isLoading = true

      var data = {
        title: this.title,
        description: this.description,
        type: this.selectedType,
        category: this.selectedCategory,
        keywords: this.keywords.map((item) => { return item.value }),
        prompt: this.prompt,
        sampleQuote: this.sampleQuote,
        sampleOutput: this.sampleOutput
      }

      const resp = await FetchWrapper.post(`${process.env.VUE_APP_SERVERURL}/createAssessmentTemplate/${this.selectedUserId}`, data)

      this.isLoading = false
      if (resp.error) {
        this.$buefy.dialog.confirm({
          title: 'Error',
          message: resp.error,
          canCancel: false
        })
      } else {
        this.$buefy.dialog.confirm({
          title: 'Success',
          message: 'Template created Successfully',
          onConfirm: () => {
            this.$emit('created')
            this.$emit('close')
            this.setInitialState()
          },
          canCancel: false
        })
      }
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Something went wrong. ${e}`,
        canCancel: false
      })
    }
  }

  setInitialState () {
    this.activeStep = 0
    this.hasStep2 = false
    this.title = ''
    this.description = ''
    this.prompt = ''
    this.keywords = []
    this.selectedType = ''
    this.selectedCategory = ''
    this.isFormValid = false
    this.sampleQuote = ''
    this.sampleOutput = ''
  }
}
